import React from "react";
import PropTypes from "prop-types";

import Button from "../Button";
import { REPORT_FEEDBACK, GO_TO_LOGIN_PAGE } from "../../constants/messages";

const ErrorActions = ({ eventId, onGoToLoginClick, onReportFeedbackClick }) => (
  <Button.ButtonGroup className="mt-4 pt-2 flex-fill">
    {onGoToLoginClick && (
      <Button onClick={onGoToLoginClick} className="flex-grow-0 mx-2">
        {GO_TO_LOGIN_PAGE}
      </Button>
    )}
    {eventId && onReportFeedbackClick && (
      <Button className="flex-grow-0 mx-2" onClick={onReportFeedbackClick}>
        {REPORT_FEEDBACK}
      </Button>
    )}
  </Button.ButtonGroup>
);

ErrorActions.propTypes = {
  eventId: PropTypes.string,
  onGoToLoginClick: PropTypes.func,
  onReportFeedbackClick: PropTypes.func,
};

export default ErrorActions;
